module.exports = __webpack_public_path__ + "media/images/meta/yogasix/apple-touch-icon_alt-b3d097e25d1ad13d80f3d9013bd70442.png";